<pulse-field>
    <div
        #fieldBox
        class="pulse-combobox__field"
        [class.pulse-combobox__field--invalid]="invalid()"
        [class.pulse-combobox__field--disabled]="isDisabled()"
        [class.pulse-combobox__field--readonly]="!searchable()"
        tabindex="-1"
        (click)="openField($event)"
    >
        @if (searchable()) {
            <span class="pulse-combobox__search-icon" aria-hidden="true"></span>
        }

        <input
            #fieldEl
            ngComboboxInput
            pulsePopupInput
            class="pulse-combobox__value"
            type="text"
            [value]="fieldText()"
            (valueChange)="searchText.set($event)"
            (blur)="markTouched()"
        />

        @if (clearable() && hasValue() && !isDisabled()) {
            <button
                type="button"
                class="pulse-combobox__clear"
                [attr.aria-label]="clearLabel() || null"
                (click)="clear($event)"
            ></button>
        }

        @if (!searchable()) {
            <span class="pulse-combobox__chevron" aria-hidden="true"></span>
        }
    </div>
</pulse-field>

<div
    #panel
    popover="manual"
    class="pulse-combobox__panel"
    [hidden]="!expanded()"
    [style.top.px]="anchor()?.top"
    [style.left.px]="anchor()?.left"
    [style.width.px]="anchor()?.width"
>
    <ng-content />
</div>
